import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';

import PitProWrapper from '../../../components/pitProWrapper';

class PitProducts extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        pitProducts: PropTypes.array,
        pitAchievement: PropTypes.array,
        pitData: PropTypes.array,
    };

    render() {
        const { pitProducts, pitAchievement, pitData } = this.props.content;

        return (
            <div className={styles.col_1000}>
                <div>
                    <div className={styles.zkcp_title}>
                        <img
                            src="https://x0.ifengimg.com/ucms/2025_44/21094BFCB382F0A55C997F848F5E9BF4F0CDC708_size7_w3000_h87.jpg"
                            width="1000"
                            height="29"
                        />
                    </div>
                    <div className={styles.space31} />
                    <Chip
                        id="55020"
                        type="recommend"
                        title="智库成果"
                        groupName="智库产品"
                        content={pitAchievement}
                        translate="handlePitProductsData">
                        <PitProWrapper />
                    </Chip>
                    <div className={styles.space31} />
                </div>
                {/* 智库大数据 */}
                <div className={styles.zhdsj}>
                    <div className={styles.zkcp_title}>
                        <img
                            src="https://x0.ifengimg.com/ucms/2025_44/6C91B2F7977CA9AA21A9B32E5137BD6D950C30D8_size8_w3000_h87.jpg"
                            width="1000"
                            height="29"
                        />
                    </div>
                    <div className={styles.space31} />
                    <Chip
                        id="55021"
                        type="recommend"
                        title="智库大数据"
                        groupName="智库产品"
                        content={pitData}
                        translate="handlePitProductsData">
                        <PitProWrapper />
                    </Chip>
                    <div className={styles.space31} />
                </div>
            </div>
        );
    }
}

export default PitProducts;
